<template>
  <div class="stock">

    <div class="not-selected" v-if="!selectedStore">
      <p>Vous devez choisir un magasin pour poursuivre la configuration</p>
    </div>

    <div class="stock-banner in-stock" v-if="selectedStore && selectedStore.stock > limited">
      <p>En stock</p>
    </div>

    <div class="stock-banner limited" v-if="selectedStore && selectedStore.stock > 0 && selectedStore.stock <= limited">
      <p>Stock limité dans cette boutique</p>
    </div>

    <div class="stock-banner out-of-stock" v-if="selectedStore && selectedStore.stock <= 0">
      <p>Téléphone indisponible dans la boutique sélectionnée</p>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Stock',
  computed: {
    ...mapState({
      selectedCode: state => state.stores.selected,
      stores: state => state.stores.items,
      limited: state => state.stores.limited,
      loading: state => state.stores.loading
    }),
    selectedStore () {
      let selectedStore = null

      this.stores.forEach((store) => {
        if(store.code === this.selectedCode) {
          selectedStore = store
        }
      })

      return selectedStore
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/tools/*';
@import '../../../../scss/mixins/*';

.stock{
  .not-selected{
    margin-top: 15px;
    background-color: darken($white, 2%);
    border: 1px solid darken($white, 5%);
    padding: 15px;
    font-size: px2rem(12px);
    line-height: px2rem(18px);
    text-align: center;
    margin-bottom: 5px;
    font-weight: $fontSemiBold;
    @include radius(10px);
  }

  .stock-banner{
    background-color: darken($white, 2%);
    border: 1px solid darken($white, 5%);
    padding: 15px;
    font-size: px2rem(12px);
    line-height: px2rem(18px);
    text-align: center;
    margin-top: 20px;
    font-weight: $fontSemiBold;
    @include radius(10px);

    &.in-stock{
      border: 1px solid rgba($greenValidate, 0.2);
      color: $greenValidate;
      background-color: rgba($greenValidate, 0.1);
    }

    &.limited{
      border: 1px solid $yellow;
      color: darken($yellow, 40%);
      background-color: rgba($yellow, 0.1);
    }

    &.out-of-stock{
      border: 1px solid rgba($red, 0.2);
      color: $red;
      background-color: rgba($red, 0.1);
    }
  }
}
</style>
